import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'bareBranch',
      d: 'M-4,-3.5h1v0.5h-1zM3,-3.5h0.5v0.5h-0.5zM-3.5,-2.5h0.5v1h-0.5zM3.5,-2.5h0.5v2.5h-0.5zM-4,-1.5h1v0.5h-1zM-3.5,-1h0.5v0.5h-0.5zM-4,-0.5h1v0.5h-1zM-4,0h0.5v0.5h-0.5zM3,0h1v0.5h-1z',
    },
    { paint: 'sandcastleWall', d: 'M-2,-2h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM-1.5,-1.5h3v0.5h-3z' },
    { paint: 'parasolStripe', d: 'M-3,-2.5h0.5v0.5h-0.5zM2.5,-2.5h0.5v1h-0.5z' },
    {
      paint: 'hammockFabric',
      d: 'M-3,-2h1v0.5h-1zM2,-2h0.5v0.5h-0.5zM1.5,-1.5h0.5v0.5h-0.5zM0,-1h0.5v0.5h-0.5zM0.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['hammockFabric', 0.65],
        ['trunk', 0.35],
      ],
      d: 'M-4,-3h1v0.5h-1zM3,-3h0.5v3h-0.5zM-4,-2.5h0.5v1h-0.5zM-2.5,-1.5h1v0.5h-1zM2,-1.5h0.5v0.5h-0.5zM-4,-1h0.5v0.5h-0.5zM-2,-1h2v0.5h-2zM0.5,-1h1.5v0.5h-1.5zM-0.5,-0.5h1v0.5h-1z',
    },
  ],
  pixels: 58,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'bareBranch',
      d: 'M-4,-3.5h1v0.5h-1zM3,-3.5h0.5v0.5h-0.5zM-3.5,-2.5h0.5v1h-0.5zM3.5,-2.5h0.5v2.5h-0.5zM-4,-1.5h1v0.5h-1zM-3.5,-1h0.5v0.5h-0.5zM-4,-0.5h1v0.5h-1zM-4,0h0.5v0.5h-0.5zM3,0h1v0.5h-1z',
    },
    {
      paint: 'sandcastleWall',
      d: 'M-2,-2h0.5v0.5h-0.5zM-2,-1.5h4v0.5h-4zM-1,-1h0.5v0.5h-0.5zM0,-1h0.5v0.5h-0.5zM1,-1h0.5v0.5h-0.5z',
    },
    { paint: 'parasolStripe', d: 'M-3,-2.5h0.5v0.5h-0.5zM2.5,-2.5h0.5v1h-0.5z' },
    {
      paint: 'hammockFabric',
      d: 'M-3,-2h1v0.5h-1zM2,-2h0.5v0.5h-0.5zM-0.5,-1h0.5v0.5h-0.5zM0.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['hammockFabric', 0.65],
        ['trunk', 0.35],
      ],
      d: 'M-4,-3h1v0.5h-1zM3,-3h0.5v3h-0.5zM-4,-2.5h0.5v1h-0.5zM-2.5,-1.5h0.5v0.5h-0.5zM2,-1.5h0.5v0.5h-0.5zM-4,-1h0.5v0.5h-0.5zM-2,-1h1v0.5h-1zM1.5,-1h0.5v0.5h-0.5zM-1,-0.5h2.5v0.5h-2.5z',
    },
  ],
  pixels: 59,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'bareBranch',
      d: 'M-4,-3.5h1v0.5h-1zM3,-3.5h0.5v0.5h-0.5zM-3.5,-2.5h0.5v1h-0.5zM3.5,-2.5h0.5v2.5h-0.5zM-4,-1.5h1v0.5h-1zM-3.5,-1h0.5v0.5h-0.5zM-4,-0.5h1v0.5h-1zM-4,0h0.5v0.5h-0.5zM3,0h1v0.5h-1z',
    },
    {
      paint: 'sandcastleWall',
      d: 'M-2,-2h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM0,-1.5h1.5v0.5h-1.5z',
    },
    { paint: 'parasolStripe', d: 'M-3,-2.5h0.5v0.5h-0.5zM2.5,-2.5h0.5v1h-0.5z' },
    {
      paint: 'hammockFabric',
      d: 'M-3,-2h1v0.5h-1zM2,-2h0.5v0.5h-0.5zM-1.5,-1.5h0.5v0.5h-0.5zM-0.5,-1.5h0.5v0.5h-0.5zM1.5,-1.5h0.5v0.5h-0.5zM0,-1h0.5v0.5h-0.5zM0.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['hammockFabric', 0.65],
        ['trunk', 0.35],
      ],
      d: 'M-4,-3h1v0.5h-1zM3,-3h0.5v3h-0.5zM-4,-2.5h0.5v1h-0.5zM-2.5,-1.5h1v0.5h-1zM2,-1.5h0.5v0.5h-0.5zM-4,-1h0.5v0.5h-0.5zM-2,-1h2v0.5h-2zM0.5,-1h1.5v0.5h-1.5zM-0.5,-0.5h1v0.5h-1z',
    },
    {
      paint: 'beachTowelA',
      d: 'M-1.5,-2.5h0.5v0.5h-0.5zM-1.5,-2h1.5v0.5h-1.5zM-1,-1.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 62,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
